import styled from "styled-components";
import { device } from "../../services/styles";

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
  @media ${device.tabletLarge} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const InfoText = styled.p`
  background-color: #fff1f2;
  border-radius: 8px;
  text-align: center;
  width: 100%;
  padding: 10px;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 20px;
`;

export const MainImage = styled.img`
  width: 100%;
`;
export const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  max-width: 100%;
  width: auto;
  max-height: 300px;
  overflow: hidden;
  margin: 0 0 20px 0;
  @media ${device.tablet} {
    width: 400px;
    height: 200px;
    margin: 0 20px 20px 0;
  }
`;

export const Lead = styled.h3`
  width: 100%;
  font-size: 16px;
  line-height: 28px;
  font-weight: 900;
  margin: 0 0 20px 0;
  @media ${device.tabletLarge} {
    width: ${(props) => (props.fullWidth ? "100%" : "calc(100% - 420px)")};
    min-width: 320px;
  }
`;

export const Video = styled.video`
  width: 100%;
  margin: 20px 0;
`;
